import { Injectable } from '@angular/core';
import { GenerateAudioPayload, GenerateBatchAudioResult, GenerateSingleAudioResult, Voices } from '@mira-avant/mtlibs';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { ApiRoots, ApiService } from './api.service';

@Injectable({
	providedIn: 'root',
})
export class AzureService {
	private readonly BASE_PATH = 'azure';

	public loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	public voices$: BehaviorSubject<Voices[]> = new BehaviorSubject<Voices[]>([]);

	constructor(private api: ApiService) {
		// Load voices
		this.getVoices$().catch(error => {
			console.error('Error fetching voices:', error);
			this.voices$.next([]);
		});
	}

	private async withLoading<T>(operation: () => Promise<T>): Promise<T> {
		this.loading$.next(true);
		try {
			return await operation();
		} finally {
			this.loading$.next(false);
		}
	}

	public async getVoices$(): Promise<Voices[]> {
		return this.withLoading(async () => {
			const voices = await firstValueFrom(this.api.get<Voices[]>(this.BASE_PATH + '/voices'));
			this.voices$.next(voices);
			return voices;
		});
	}

	public async generateSingleAudio$(payload: GenerateAudioPayload): Promise<GenerateSingleAudioResult> {
		return this.withLoading(async () => {
			const result = await firstValueFrom(
				this.api.post<GenerateSingleAudioResult>(
					this.BASE_PATH + '/single-audio',
					payload,
					undefined,
					ApiRoots.JOURNEY_UPLOADER
				)
			);
			return result;
		});
	}

	public async generateBatchAudio$(payload: GenerateAudioPayload): Promise<GenerateBatchAudioResult> {
		return this.withLoading(async () => {
			const result = await firstValueFrom(
				this.api.post<GenerateBatchAudioResult>(
					this.BASE_PATH + '/batch-audio',
					payload,
					undefined,
					ApiRoots.JOURNEY_UPLOADER
				)
			);
			return result;
		});
	}
}
